/** the most decimals a leak size or a pressure is shown with, in whichever unit it is shown in */
export const DIALOG_EVENT_MEASURE_DECIMALS = 3;
